export interface ActionRequiredParts {
    /** The shared leading text, or null when the label has no separator to split on. */
    prefix: string | null;
    field: string;
}

const SEPARATOR = ' - ';

/** Separates an "Action Required" label into its shared prefix and the field name that varies.
 *
 * Labels are built in several shapes: most read "<something> Matching - <field>", but some are a
 * bare "<Field> Review" with no separator, and the separator is dropped entirely when there is no
 * field label to follow it. Splitting on the LAST separator keeps a field that itself contains one
 * attached to the prefix rather than losing the front of it.
 */
export function splitActionRequired(label: string): ActionRequiredParts {
    const at = label.lastIndexOf(SEPARATOR);
    if (at < 0) {
        return { prefix: null, field: label };
    }
    return { prefix: label.slice(0, at), field: label.slice(at + SEPARATOR.length) };
}
